import React from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function NotFound() {
  return <section className="not-found page-width"><h1>Page not found.</h1><p>The page you’re looking for doesn't exist.</p><Link className="button-primary" to="/#articles"><ArrowBackIcon /> Back to the writing</Link></section>;
}
